var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoliday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94766 6.84774L1.9489 8.29476C1.28918 8.53349 1.28918 9.46651 1.9489 9.70525L5.94766 11.1523C6.36642 11.3038 6.6962 11.6336 6.84774 12.0523L8.29476 16.0511C8.53349 16.7108 9.46651 16.7108 9.70525 16.0511L11.1523 12.0523C11.3038 11.6336 11.6336 11.3038 12.0523 11.1523L16.0511 9.70525C16.7108 9.46651 16.7108 8.53349 16.0511 8.29475L12.0523 6.84774C11.6336 6.6962 11.3038 6.36642 11.1523 5.94766L9.70525 1.9489C9.46651 1.28918 8.53349 1.28918 8.29476 1.9489L6.84774 5.94766C6.6962 6.36642 6.36642 6.6962 5.94766 6.84774Z",
    stroke: "#98A1B2",
    strokeWidth: 1.9375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9235 19.023L17.0646 19.6515C17.1104 19.8552 17.2912 20 17.5 20C17.7088 20 17.8896 19.8552 17.9354 19.6515L18.0765 19.023C18.1824 18.551 18.551 18.1824 19.023 18.0765L19.6515 17.9354C19.8552 17.8896 20 17.7088 20 17.5C20 17.2912 19.8552 17.1104 19.6515 17.0646L19.023 16.9235C18.551 16.8176 18.1824 16.449 18.0765 15.977L17.9354 15.3485C17.8896 15.1448 17.7088 15 17.5 15C17.2912 15 17.1104 15.1448 17.0646 15.3485L16.9235 15.977C16.8176 16.449 16.449 16.8176 15.977 16.9235L15.3485 17.0646C15.1448 17.1104 15 17.2912 15 17.5C15 17.7088 15.1448 17.8896 15.3485 17.9354L15.977 18.0765C16.449 18.1824 16.8176 18.551 16.9235 19.023Z",
    fill: "#98A1B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoliday);
export default __webpack_public_path__ + "static/media/holiday.cb65f26f3b3f8dcde5ceca7553035375.svg";
export { ForwardRef as ReactComponent };